import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Button, Col, Row } from "antd";
import { Back } from "../../../../components/User/CourseOnline/Generals";
import { MenuLessons } from "../../../../components/User/CourseOnline/Menu";
//import introImg from "../../../../assets/img/CourseOnline/introduccion.png";
//import introImgIzq from "../../../../assets/img/CourseOnline/introduccionIzq.png";
import tituloImg from "../../../../assets/img/CourseOnline/titulo.png";
import { Title } from "../../../../components/User/CourseOnline/Title";
import "./Courses.scss";
//import { capitalizeWord } from "../../../../components/Generals/functions";
//import { CONST_RANGO_ANIO_FECHA_JORNADA, } from "../../../../utils/constanst";

/**
 * Pantalla 2
 * Componentes que muestra la pantalla de introducción al inicar el curso de una entidad
 * path: /ciudadano/introduccion
 */
function Introduccion(props) {
  const { idEntidad, entidad } = useSelector((state) => state.entidad);
  const { loading } = useSelector((state) => state.menu);
  //const { temario } = useSelector((state) => state.menu);
  const row = 18;
  const xxL = 6;

  useEffect(() => {
    window.scrollTo(0, 0); // para posicionar el scroll al inicio
  }, []);

  /*const countLessons = () => {
    let lessons = 0;
    temario.forEach((item) => {
      if (item.tipoLeccion === 1) {
        lessons += 1;
      }
    });
    return getNumber(lessons);
  };*/

  //console.log(numberLesson);
  if (!idEntidad) {
    return <Redirect to="/ciudadano/capacitacion" />;
  }
  return (
    <>
      <Back path="/ciudadano/capacitacion" />

      <Title entitie={entidad} lesson={"Presentación del curso"} />

      <Row gutter={24} className="material">
        <Col span={row} xxl={row} xl={row} lg={row} md={row} sm={24} xs={24}>

          <div className="texto_parrafo">

            <img src={tituloImg} alt="img" className="imagen" width={'100%'}/> <br />

            <p>
              En este curso identificarás las características y las particularidades de la elección de las personas 
              juzgadoras, así como las actividades que se realizan en cada una de las etapas del Proceso Electoral 
              Extraordinario del Poder Judicial de la Federación 2024-2025, quiénes son los responsables de realizarlas 
              y cómo se llevan a cabo. 
            </p>

            <p>
              Tu curso está integrado por siete lecciones, en cada una de las cuales encontrarás la información necesaria, 
              los recursos y las herramientas didácticas para tu capacitación. Al finalizar cada lección habrá una actividad 
              autoevaluable, y al concluir el curso, una evaluación final. Deberás realizar todas las autoevaluaciones y en 
              la evaluación final obtener una calificación mínima de 7 para recibir tu constancia de capacitación. 
            </p>

            <p>
              En todo momento tendrás acceso a tu Guía, a la normatividad electoral federal vigente y a los instrumentos para 
              aplicar medidas de inclusión en las distintas etapas del proceso electoral aprobados por el Instituto. Además, 
              podrás consultar el material didáctico sobre las particularidades de la elección local de las entidades que 
              celebren elecciones del Poder Judicial Local concurrentes con la elección del Poder Judicial Federal.
            </p>

            <p> Recuerda que tu participación como observadora u observador electoral es fundamental y su importancia se 
                refleja en cada etapa del proceso electoral.
            </p>

            <p className="textoResaltado bold" style={{textAlign: "center", fontSize: "15pt"}}>
              <b>¡Agradecemos tu interés en formar parte activa de la democracia de nuestro país!</b>
            </p>

          </div>

          <Link to={{ pathname: "/ciudadano/lecciones" }} disabled={loading}>

            <Button type="primary"
                    disabled={loading}
                    style={{ marginBottom: 30 }} >

              Ir a la lección 1

            </Button>

          </Link>

        </Col>

        <Col span={xxL} xxl={xxL} xl={xxL} lg={xxL} md={xxL} sm={24} xs={24}>
          {/* Se manda null el index para que no muestre seleccionado ninguna lección */}

          <MenuLessons index={null} />

        </Col>
      </Row>
    </>
  );
}

export default withRouter(Introduccion);
